<template lang="pug">
.List
  .List__title Page List
  ul.List__list
    li.List__item(v-for="page in pageList")
      a(:href="page.url")
        .List__item__title {{ page.name }}
</template>
<script>
import RssList from '@/components/page-components/RssList.vue';

export default {
  name: 'List',
  components: {
    RssList,
  },
  data() {
    return {
      pageList: [
        {
          name: 'rss',
          url: 'https://git.page/ziv/rss',
        },
        {
          name: 'youtube',
          url: 'https://git.page/ziv/youtube',
        },
        {
          name: 'url',
          url: 'https://git.page/ziv/url',
        },
        {
          name: 'button',
          url: 'https://git.page/ziv/button',
        },
        {
          name: 'sticker',
          url: 'https://git.page/ziv/sticker',
        },
        {
          name: 'display',
          url: 'https://git.page/ziv/display',
        },
      ],
    };
  },
};
</script>
<style lang="sass">
.List
  +size(100%, 100%)
  +flex(flex-start, center, column)
  &__title
    +title($size: $xl)
    position: relative
    padding: 1rem
    margin-bottom: 2rem
    &:after
      +size(100%, .15rem)
      content: ''
      position: absolute
      bottom: 0
      left: 50%
      transform: translateX(-50%)
      background-color: fade-out($secondary, .4)
  &__list
    text-align: center
  &__item
    +pointer
    box-sizing: border-box
    border-radius: 5px
    margin-bottom: .5rem
    transition: all .5s
    padding: .5rem 1rem
    &:hover
      background-color: fade-out($secondary, .9)
      transition: all .5s
      .List__item__title
        color: lighten($text, 30%)
        transform: translateX(1%)
        transition: all .5s
    &__title
      +text
      font-weight: 600
      padding: .4rem 0
      transition: all .5s
</style>
